(function () {
    "use strict";

    // @ngInject
    function TopNavIntroControllerCtor($scope, $injector, $state, $modalInstance, AppStates,
                                    AnalyticsService, EventsManager, EventService, WorkspaceService, CompaniesManager,
                                    PopupMessageService, UsersManager, UserService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'TopNavIntroController';

        this.EventsManager = EventsManager;
        this.EventService = EventService;
        this.WorkspaceService = WorkspaceService;
        this.$state = $state;
        this.appStates = AppStates;
        this.modalInstance = $modalInstance;
        this.companiesManager = CompaniesManager;
        this.AnalyticsService = AnalyticsService;
        this.PopupMessageService = PopupMessageService;
        this.UsersManager = UsersManager;
        this.UserService = UserService;

        this.currUser = UsersManager.getCurrUser();
        this.phoneNumber = "";
        if (this.currUser.phone_number) {
            this.phoneNumber = this.currUser.phone_number;
        } else if (this.currUser.company) {
            this.phoneNumber = this.currUser.company.phone_number;
        }

        this.$scope = $scope;

        AnalyticsService.track(this, "load", {unique: "top_nav_intro",source: "popup"});

    }

    Controllers.TopNavIntroController = Class(Controllers.BaseController, {
        constructor: TopNavIntroControllerCtor,

        cancelIntroTip: function cancelIntroTip(){
            this.modalInstance.dismiss();
        },
    });
}());

